import { Paper, Link, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { customPalette } from '../../../styles/palette';

export const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: '#fff',
  ...theme.typography.body2,
  padding: '0.9375rem',
  textAlign: 'center',
  color: theme.palette.text.secondary,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  boxShadow: 'none',
  gap: '0.625rem'
}));

export const TypographyStyledBlack = styled(Typography)(() => ({
  color: customPalette.primaryDark,
  fontSize: '1.875rem',
  fontWeight: 450,
  '@media(max-width:767px)': {
    fontSize: '1.65rem'
  }
}));

export const LinkStyled = styled(Link)(() => ({
  color: '#002A3A',
  fontSize: '1.625rem',
  fontWeight: 450,
  fontFamily: 'BrandonGrotesqueRegular',
  textDecoration: 'none',
  '&:active': {
    border: '0.125rem solid #004F71',
    background: 'transparent',
    p: {
      color: '#004F71'
    }
  },
  '&:hover': { cursor: 'pointer' }
}));
